import { z } from "zod";

export const recontractingRequestSchema = z.object({
  crmObjectId: z.string().nullable(),
  recontractingVariant: z.string().nullable(),
});

export type Campaigns = z.infer<typeof recontractingRequestSchema>;
